export const LAST_USED_TENANT_ID = 'admin-ui:lastUsedTenantId';
export const LAST_USED_TENANT_NAME = 'admin-ui:lastUsedTenantName';
export const ADMIN_CUSTOMER_UI_THEME = 'admin-ui:theme';
export const WELCOME_DIALOG_SEEN = 'admin-ui:welcomeDialogSeen';
